import React from 'react'
import Divider from 'LuxKit/Divider'
import MerchandiseMegaMenuContainer from './components/MerchandiseMegaMenuContainer'
import MerchandiseMegaMenuPanel from './components/MerchandiseMegaMenuPanel'
import MerchandiseMegaMenuFeaturedBrands from './components/MerchandiseMegaMenuFeaturedBrands'
import MerchandiseBrandsAlphabet from './components/MerchandiseBrandsAlphabet'

interface Props {
  selectedLetter?: string
  onLetterSelect: (letter: string) => void
  onClose: () => void
}

function MerchandiseBrandsMegaMenu(props: Props) {
  const {
    selectedLetter,
    onLetterSelect,
    onClose,
  } = props

  return <MerchandiseMegaMenuContainer>
    <MerchandiseMegaMenuPanel $panels={2}>
      <MerchandiseMegaMenuFeaturedBrands
        panels={2}
        columns={5}
        limit={15}
        onClose={onClose}
      />
    </MerchandiseMegaMenuPanel>
    <Divider kind="secondary" direction="vertical" />
    <MerchandiseMegaMenuPanel>
      <MerchandiseBrandsAlphabet
        selectedLetter={selectedLetter}
        onLetterSelect={onLetterSelect}
        onClose={onClose}
      />
    </MerchandiseMegaMenuPanel>
  </MerchandiseMegaMenuContainer>
}

export default MerchandiseBrandsMegaMenu
